import React, { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Button,
  makeStyles,
  CardMedia,
  List,
  ListItem,
  Typography,
  Divider,
  ListItemIcon,
  Grid,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord"; // Bullet point icon
import "../styles/cardComponent.css";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { formatDate } from "../../utils/constant";

const LatestBlogs = ({ data, showBlog, blogs }) => {
  const date = formatDate(data.attributes.createdAt);
  const url = process.env.REACT_APP_STRAPI_API;

  return (
    <Box sx={{ width: "100%", display: "inline-block" }}>
      <img
        style={{ borderRadius: "8px 8px 0px 0px", width: "100%" }}
        component="img"
        height="150px"
        // width="240px"
        //   image={imageData}
        alt="Card Image"
        src={`${data.attributes.cardImage.data.attributes.url}`}
      //   src={imageData ?? "https://upload.wikimedia.org/wikipedia/commons/b/bf/Incred-logo.jpg"}
      />

      <Card className="latestBlogCard"
        sx={{
          width: "100%",
          // width: blogs === 3 ? "279px" : "363px",
          // maxWidth:"424px",
          backgroundColor: "#212121",
          padding: "15px",
          color: "#b6b4b4",
          borderRadius: "0px 0px 8px 8px",
          height: '315px',
          position: "relative",
        }}
      >
        <ListItem className="listingItems">
          <Typography color="white" variant="h6" style={{ lineHeight: "inherit" }}>
            {data.attributes.cardHeading}{" "}
          </Typography>
        </ListItem>
        <ListItem className="listingItems">
          <Typography color="#b6b4b4" style={{ fontSize: "14px" }}>{date} </Typography>
        </ListItem>
        <CardContent style={{ padding: "0" }}>
          <List className="cardDetailsOverFlow">
            <ListItem className="listingItems">
              <Typography color="#b6b4b4" style={{ fontSize: "18px" }}>
                {" "}
                {data.attributes.cardContent}
              </Typography>
            </ListItem>
          </List>
        </CardContent>

        <Button className="investButton1 positionBtnDown" onClick={() => showBlog(data.id)}>
          Read More
        </Button>
      </Card>
    </Box>
  );
};

export default LatestBlogs;
